/* eslint-disable react/jsx-props-no-spreading */
import {
  Col,
  Collapse,
  Divider,
  Empty,
  Input,
  Pagination,
  Result,
  Row,
  Select,
  Space,
  Spin,
  Typography,
  Upload,
} from 'antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getCategories, getDocumentDetail, getDocuments } from 'services/notice';

function List({ docs, ...rest }) {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [fileList, setFileList] = useState([]);

  return (
    <>
      {docs.length !== 0 ? (
        <Collapse
          {...rest}
          onChange={async (guid) => {
            if (!guid) {
              return;
            }
            setLoading(true);
            const faq = await getDocumentDetail(guid);
            setFileList(
              faq.notice.fileInfo.map((fInfo, i) => ({
                uid: `${i}`,
                name: fInfo.filename,
                status: 'done',
                url: `/portal/api/notice/document/${guid}/download?file=${fInfo.hash}`,
                linkProps: { download: fInfo.filename },
                hash: fInfo.hash,
              })),
            );
            if (faq.notice) {
              setError(false);
              setValue(faq.notice.contents);
            } else {
              setValue(faq.error);
              setError(true);
            }
            setLoading(false);
          }}
        >
          {docs?.map((item) => (
            <>
              <Collapse.Panel header={item.title} key={item.guid}>
                <Spin spinning={loading}>
                  {!isError ? (
                    <>
                      <ReactQuill theme="bubble" value={!loading && value} readOnly />
                      {fileList.length !== 0 && (
                        <>
                          <Divider />
                          <Typography.Title type="secondary" level={5}>
                            첨부파일
                          </Typography.Title>
                          <Upload
                            multiple
                            fileList={fileList}
                            showUploadList={{
                              showDownloadIcon: true,
                              downloadIcon: 'download',
                              showRemoveIcon: false,
                            }}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <Result status="warning" title={!loading && value} />
                  )}
                </Spin>
              </Collapse.Panel>
            </>
          ))}
        </Collapse>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </>
  );
}

function Faq() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [docs, setDocs] = useState([]);
  const [searchVal, setSearchVal] = useState({ key: 'title', value: '' });
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    pageSize: 10,
    type: 'faq',
  });

  const [reRendering, setRerendering] = useState(true);

  useEffect(() => {
    if (!reRendering) {
      return;
    }

    const params = {
      ..._.pickBy(
        paginationInfo,
        (__, key) => key !== 'data' && key !== 'success' && key !== 'total',
      ),
      type: 'faq',
    };

    if (searchVal.value) {
      params[searchVal.key] = searchVal.value;
    }

    if (selectedCategory) {
      params.categoryId = selectedCategory;
    }

    getDocuments(params).then((documents) => {
      setDocs(documents.data);
      setPaginationInfo(_.pickBy(documents, (__, key) => key !== 'data' && key !== 'success'));
      setRerendering(false);
    });
  }, [reRendering]);

  useEffect(() => {
    getCategories({ type: 'faq' }).then((data) => {
      let result = [];
      result = data.map((item) => ({ label: item.name, value: item.categoryId }));
      setCategories(result);
      setSelectedCategory(null);
    });
  }, []);

  return (
    <Row gutter={[0, 16]}>
      <Col span={24}>
        <Space>
          <Select
            size="large"
            style={{ width: 160 }}
            defaultValue={null}
            options={[{ label: '전체', value: null }, ...categories]}
            onChange={(value) => {
              setSelectedCategory(value);
              setRerendering(true);
            }}
          />
          <Input.Group compact style={{ display: 'flex' }}>
            <Select
              size="large"
              defaultValue={searchVal?.key}
              style={{ width: 100 }}
              options={[{ label: '제목', value: 'title' }]}
              onChange={(value) => {
                setSearchVal((prev) => ({ ...prev, key: value }));
              }}
            />
            <Input.Search
              size="large"
              allowClear
              placeholder="검색"
              onSearch={(val) => {
                setSearchVal((prev) => ({ ...prev, value: val }));
                setRerendering(true);
              }}
            />
          </Input.Group>
        </Space>
      </Col>
      <Col span={24}>
        <List accordion docs={docs} />
      </Col>
      {docs.length !== 0 && (
        <Col span={24}>
          <div style={{ textAlign: 'right' }}>
            <Pagination
              {...paginationInfo}
              onChange={(current, pageSize) => {
                setPaginationInfo((prev) => ({ ...prev, current, pageSize }));
                setRerendering(true);
              }}
              showSizeChanger
              onShowSizeChange={(current, pageSize) => {
                setPaginationInfo((prev) => ({ ...prev, current, pageSize }));
                setRerendering(true);
              }}
            />
          </div>
        </Col>
      )}
    </Row>
  );
}

export default Faq;
export { List as FaqList };
